module.exports = __webpack_public_path__ + "img/italy.6cc2eb11.svg";